import { PbsPlacement } from '@pubstack/common/src/pbs/placements'
import { sortByName } from '@pubstack/common/src/sort'
import { useMemo } from 'react'
import { useQuery } from '../api-client'

export const PLACEMENTS_QUERY_KEYS = ['pbs', 'placements']

//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------

export const usePlacements = (enabled = true) => {
  const queryResult = useQuery<PbsPlacement[]>({
    url: '/pbs/placements',
    keys: PLACEMENTS_QUERY_KEYS,
    enabled,
    select: sortByName,
  })

  const data = useMemo(() => queryResult.data || [], [queryResult.data])

  return { ...queryResult, data }
}
